import React from 'react'

import { Separator } from '@/components/ui/separator'

interface NotificationPreferenceRowSkeletonProps {
  showSeparator?: boolean
}

export const NotificationPreferenceRowSkeleton: React.FC<
  NotificationPreferenceRowSkeletonProps
> = ({ showSeparator = false }) => {
  return (
    <div className="flex flex-col rounded-2xl">
      <div className="flex flex-col items-start gap-3 p-6 lg:flex-row lg:gap-14">
        <div className="w-full md:max-w-[560px]">
          <div className="w-48 h-5 rounded bg-gray-light-200 animate-pulse" />
          <div className="w-full h-4 mt-2 rounded bg-gray-light-100 animate-pulse" />
        </div>

        <div className="flex-shrink-0 w-full md:w-50">
          <div className="w-full h-10 rounded-lg bg-gray-light-200 animate-pulse" />
        </div>
      </div>

      {showSeparator && (
        <Separator className="bg-gray-light-200 w-[96%] mx-auto" />
      )}
    </div>
  )
}
